// 使用 localStorage 作为缓存存储
class LocalStorageCache {
  constructor() {
    this.prefix = 'game_portal_';
  }

  getFullKey(key) {
    return this.prefix + key;
  }

  async set(key, data, expireTime = 3600) {
    try {
      const fullKey = this.getFullKey(key);
      const item = {
        data,
        timestamp: Date.now(),
        expiry: Date.now() + (expireTime * 1000)
      };
      localStorage.setItem(fullKey, JSON.stringify(item));
      console.log(`Cache set for key: ${key}`);
      return true;
    } catch (error) {
      console.error('Cache set error:', error);
      return false;
    }
  }

  async get(key) {
    try {
      const fullKey = this.getFullKey(key);
      const item = localStorage.getItem(fullKey);
      
      if (!item) {
        console.log(`Cache miss for key: ${key}`);
        return null;
      }

      const { data, expiry } = JSON.parse(item);
      
      // 检查是否过期
      if (Date.now() > expiry) {
        localStorage.removeItem(fullKey);
        console.log(`Cache expired for key: ${key}`);
        return null;
      }

      console.log(`Cache hit for key: ${key}`);
      return data;
    } catch (error) {
      console.error('Cache get error:', error);
      return null;
    }
  }

  // 清除过期的缓存
  cleanup() {
    try {
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith(this.prefix)) {
          const item = JSON.parse(localStorage.getItem(key));
          if (item.expiry && Date.now() > item.expiry) {
            localStorage.removeItem(key);
          }
        }
      });
    } catch (error) {
      console.error('Cache cleanup error:', error);
    }
  }
}

const cache = new LocalStorageCache();

// 定期清理过期缓存
setInterval(() => cache.cleanup(), 60 * 1000); // 每分钟清理一次

export const setCache = async (key, data, expireTime = 3600) => {
  return cache.set(key, data, expireTime);
};

export const getCache = async (key) => {
  return cache.get(key);
};
export const cleanup = async () => {
  return cache.cleanup();
};
export default cache; 